import React, { useState } from "react";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { ButtonStyleAzul, DivBackgroundDasboard, PaperStyle, TypographyStyleSecundary } from "../../styles/Styles";
import { ListItemButton } from "@mui/material";
import { useNavigate } from "react-router-dom";


const ListadoComponent = ({ data }) => {
    let history = useNavigate();
    // console.log("data", data);
    let colorPendiente = '#f29345';
    let colorCancelado = '#d84948';
    let colorAprobado = '#5d965c';

    const handleDetails = (item) => {
        console.log("item", item);
        history(`/historial/informacion`, { state: item });
    }


    const handleMontoPagado = (item) => {
        let montoPagado = 0;
        const tieneImporte = item && item.importe !== undefined && item.importe !== null;
        const tieneMonto = item && item.monto !== undefined && item.monto !== null;

        if (tieneImporte) {
            montoPagado = item.importe.toString().replace('00', '');
            return `Gs. ${parseInt(montoPagado || '0').toLocaleString('es-PY', { minimumFractionDigits: 0 })}`;
        }

        if (tieneMonto) {
            montoPagado = item.monto.toString().replace('00', '');
            return `Gs. ${parseInt(montoPagado || '0').toLocaleString('es-PY', { minimumFractionDigits: 0 })}`;
        }

        return 'Gs. 0';
    };

    const handleFechaPagos = (item) => {
        let fechaPago = '';
        let validPagos = item && item.fechaPago;


        if (validPagos) {
            fechaPago = item.fechaPago;
        } else {
            fechaPago = item.fechaCreacion;
        }

        return fechaPago;
    };

    const handleEstado = (item) => {
        let estado = '';
        let validPagos = item && item.estadoPago;


        if (validPagos) {
            estado = item.estadoPago === 'Payment' ? 'Pagado' : item.estadoPago;
        } else {
            // estado = item.estado;
            if (item?.estado === 'PE') {
                estado = 'Pendiente';
            } else if (item?.estado === 'RE') {
                estado = 'Rechazado';
            } else if (item?.estado === 'AP') {
                estado = 'Aprobado';
            }
        }

        return estado.toUpperCase();
    };

    const handleColorEstado = (item) => {
        let color = '';
        let validPagos = item && item.estadoPago;


        if (validPagos) {
            if (item.estadoPago === 'Pendiente') {
                color = colorPendiente;
            } else if (item.estadoPago === 'Rechazado') {
                color = colorCancelado;
            } else if (item.estadoPago === 'PAGADO' || item.estadoPago === 'Payment') {
                color = colorAprobado;
            }
        } else {
            if (item?.estado === 'PE') {
                color = colorPendiente;
            } else if (item?.estado === 'RE') {
                color = colorCancelado;
            } else if (item?.estado === 'AP') {
                color = colorAprobado;
            }
        }

        return color;
    };

    return (
        <PaperStyle>
            {data && data.map((item, index) => {
                return (
                    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                        <ListItemButton onClick={() => handleDetails(item)} key={index}>
                            <ListItemText
                                primaryTypographyProps={{
                                    style: {
                                        // textAlign: 'right',
                                    }
                                }}
                                primary={
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        flexWrap: 'wrap',
                                        gap: '4px',
                                    }}>
                                        <Typography
                                            sx={{ fontSize: '1rem', wordBreak: 'break-all', flex: '1 1 auto' }}
                                            component="span"
                                            variant="body2"
                                        >
                                            {item.idTxDestinatario || item.idOperacion || ''}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                textAlign: 'right',
                                                whiteSpace: 'nowrap',
                                                marginLeft: 'auto',
                                            }}
                                            component="span"
                                            variant="body2"
                                        >
                                            {handleMontoPagado(item)}
                                        </Typography>
                                    </div>
                                }
                                secondary={
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                    }}>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            style={{
                                                // color: item.estado === 'Pendiente' ? colorPendiente : item.estado === 'Cancelado' ? colorCancelado : colorAprobado
                                                color: handleColorEstado(item)
                                            }}
                                        >
                                            {/* {item.estadoPago} */}
                                            {handleEstado(item)}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                textAlign: 'right',
                                            }}
                                            component="span"
                                            variant="body2"
                                        >
                                            {/* {`${item.fechaPago}`} */}
                                            {handleFechaPagos(item)}
                                        </Typography>
                                    </div>
                                }
                            />
                        </ListItemButton>
                        
                        {data.length > 1 && index !== data.length - 1 &&
                            <Divider variant="fullWidth" component="li" />
                        }
                    </List>
                )
            })}
        </PaperStyle>
    )
}

export default ListadoComponent;